import { Row } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import type { FunctionalComponent } from 'preact'
import matrixPng from './img/matrix.png'
import natalPng from './img/natal.png'
import styles from './index.module.scss'

export const HeroMobile: FunctionalComponent = () => {
  return (
    <Row class={styles.mobile} gap={15}>
      <section class={styles.hero}>
        <Row alignItems='center' gap={30}>
          <Text
            fontSize={24}
            fontWeight={700}
            lineHeight={1}
          >
            ZoeAstro
          </Text>

          <div class={styles.art}>
            <img class={styles.natal} src={natalPng} alt='Пример натальной карты' />
            <img class={styles.matrix} src={matrixPng} alt='Пример матрицы судьбы' />
          </div>

          <Row gap={15}>
            <Text as='h1' fontSize={24} lineHeight={1} fontWeight={600} textAlign='center'>
              Твоя натальная карта<br />и матрица судьбы
            </Text>
            <Text as='p' fontSize={14} lineHeight={1.25} textAlign='center' opacity={0.7}>
              Открой свои сильные стороны<br />и скрытый потенциал
            </Text>
          </Row>
        </Row>
      </section>

      <Row gap={15} alignItems='center'>
        <UI.Button
          block
          size='l'
          type='primary'
          link='~/tools'
        >
          Начать разбор
        </UI.Button>

        <UI.Hint>
          Бесплатный старт · Без карты · 1 минута
        </UI.Hint>
      </Row>
    </Row>
  )
}
